import { FunctionComponent } from "react";

import { FlexContainer, StyledTreeSelect, Wrapper } from "./DataTableColumnChooser";
import useMonthlyProduction from "./hooks/useMonthlyProduction";

const PLANT_LIQUID_KEYS = ["c2", "c3", "c4", "c5"];
const STREAMS = ["Oil + Cond", "Gas", "Water"];
const PLANT_LIQUIDS = ["C2", "C3", "C4", "C5+"];

// The field selector's own container and chip styling, locked: the monthly streams are
// fixed by the service, so the chips cannot be removed and the dropdown never opens.
const MonthlyFieldSelector: FunctionComponent = () => {
  const { data } = useMonthlyProduction();

  const hasPlantLiquids = data?.columns.some((column) =>
    PLANT_LIQUID_KEYS.includes(column.key)
  );
  const chips = hasPlantLiquids ? [...STREAMS, ...PLANT_LIQUIDS] : STREAMS;

  return (
    <Wrapper role="group" aria-label="Monthly production streams">
      <FlexContainer data-testid="monthly-field-selector">
        <StyledTreeSelect
          treeCheckable
          showArrow={false}
          showSearch={false}
          allowClear={false}
          open={false}
          treeData={chips.map((chip) => ({ value: chip, title: chip }))}
          value={chips}
          tagRender={({ label }) => (
            <span className="ant-select-selection-item">
              <span className="ant-select-selection-item-content">{label}</span>
            </span>
          )}
        />
      </FlexContainer>
    </Wrapper>
  );
};

export default MonthlyFieldSelector;
